import { graphql, useStaticQuery } from 'gatsby';

type ContentfulResourceType = {
    allContentfulResource: {
        nodes?: Array<NodesType>;
    };
};

type NodesType = {
    value?: { value: string };
    key?: string;
};

const useText = (key: string): string => {
    const { allContentfulResource } = useStaticQuery<ContentfulResourceType>(
        graphql`
            query resourceQuery {
                allContentfulResource {
                    nodes {
                        value {
                            value
                        }
                        key
                    }
                }
            }
        `
    );

    const { nodes } = allContentfulResource;
    const str = nodes?.find((node) => node?.key === key)?.value?.value;

    if (!str) {
        return key;
    }

    return str;
};

export default useText;
